import React from 'react';
import  '../styles/Home.css';
import  '../styles/HomeAbout.css';
import  '../styles/HomeServices.css';


const HomeAbout=()=>{
    return (
        <div>
             <div className="about-background">
                  <div className="about-image">
                        <div className="about-head">
                             <h1>About Us</h1>
                        </div>
                        <div className="about-para">
                             <p>Our Taxtimez firm has been providing comprehensive tax solutions to businesses of all sizes for over a decade.we pride ourselves on your deep expertise,personalized service</p>
                        </div>
                  </div>

                  <div className="about-boxes">
                    {/* <!-- box1 start  --> */}
                               <div className="grid-item-about">
                        <div className="grid-item-inner-about">
                         <div className="grid-list-wrapper-about">
                            <div className="grid-list-about">

                                <div className="tax-icon-about">
                                    <img src="./images/home/about/tax.png" alt="service1 not found" />
                                </div>
                                 
                                     <h1 className="about-head" sx="margin:5px"><span>Comprehensive <br/>Tax</span></h1>
                              
                                <p className="grid-list-para-about">Tailored stratiges for your financial prosperity </p>


                        


                              
                               
                            </div>
                           </div>
                        </div>
                   
                    </div>
                    {/* <!-- box1 end --> */}

                    {/* <!-- box2 start  --> */}
                      <div className="grid-item-about">
                        <div className="grid-item-inner-about">
                         <div className="grid-list-wrapper-about">
                            <div className="grid-list-about">


                                
                             

                               <div className="tax-icon-about">
                                    <img src="./images/home/about/decision.png" alt="service1 not found" />
                                </div>
                               
                                 
                                     <h1 className="about-head" sx="margin:5px"><span>Personalized <br/>approach</span></h1>
                              
                                <p className="grid-list-para-about">Maxamize your savings with our expertise </p>


                            </div>
                           </div>
                        </div>
                   
                    </div>
                     {/* <!-- box2 end  --> */}

                     {/* <!-- box3 start --> */}
                       <div className="grid-item-about">
                        <div className="grid-item-inner-about">
                         <div className="grid-list-wrapper-about">
                            <div className="grid-list-about">


                             

                               <div className="tax-icon-about">
                                    <img src="./images/home/about/guidance.png" alt="service1 not found" />
                                </div>
                               
                                 
                                     <h1 className="about-head" sx="margin:5px"><span>Expert  <br/> Guidance</span></h1>
                              
                                <p className="grid-list-para-about">Simplify your tax complexeties, achieve greater wealth </p>


                            </div>
                           </div>
                        </div>
                   
                    </div>
                      {/* <!-- box3 end --> */}

                      {/* <!-- box4 start --> */}
                        <div className="grid-item-about">
                        <div className="grid-item-inner-about">
                         <div className="grid-list-wrapper-about">
                            <div className="grid-list-about">

                                <div className="tax-icon-about">
                                    <img src="./images/home/about/handshake.png" alt="service1 not found" />
                                </div>
                                
                                     <h1 className="about-head" sx="margin:5px"><span>Trusted <br/>Partnerships</span></h1>
                               
                                <p className="grid-list-para-about">Seamless Tax Management for your Financial Growth </p>


                             

                             
                               
                            </div>
                           </div>
                        </div>
                   
                    </div>
                       {/* <!-- box4 end --> */}
                  </div>
            </div>
        </div>
    )
}

export default HomeAbout;